/* eslint-disable */
const GrinInit = () => {
  (function () {
    Grin = window.Grin || (window.Grin = []);
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://d38xvr37kwwhcm.cloudfront.net/js/grin-sdk.js';
    s.none = 'EDNnf03nceIOfn39fn3e9h3sdfa';
    const x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  })();
}

export default GrinInit;
